import { useReduxUI } from "../../hooks/redux/useReduxUI";

export const MenuItem = ({ label, icon, onClick, isActive, isLast = false }) => {
    const {
        state: { isOpenMenu },
    } = useReduxUI();

    return (
        <li
            className={
                `cursor-pointer list-none flex justify-start items-center gap-2 py-[10px] transition-colors duration-500 rounded-md  
                ${isActive ? "bg-[#1677FF]" : ""}
                ${!icon ? "pl-6" : "pl-4"} ${isOpenMenu ? "" : "lg:justify-center lg:px-6"} 
                ${isLast && " w-full  absolute bottom-0"}
                `}
            onClick={onClick}
        >
            {icon && <>{icon}</>}
            {isOpenMenu && <span className={`${!icon ? "pl-6" : ""}`}>{label}</span>}
        </li>
    );
};
